import { T_RESPONSE, LLMProvider } from "../types";

/**
 * Request type for DASH_COMP_REQ
 */
export type DashCompReqType = 'create' | 'update' | 'filter';

/**
 * Response type for dash comp request
 */
export interface DashCompResponse extends T_RESPONSE {
	id?: string;
	wsId?: string;
}

/**
 * Default models for DASH_COMP flow (can be overridden via config)
 * Using faster/cheaper models since DASH_COMP is a simpler task
 */
export const DEFAULT_DASH_COMP_MODELS: Record<LLMProvider, string> = {
	anthropic: 'anthropic/claude-haiku-4-5-20251001',
	gemini: 'gemini/gemini-3-flash-preview',
	openai: 'openai/gpt-4o-mini',
	groq: 'groq/llama-3.3-70b-versatile'
};
